<template>

  <div class="rows maitrises">
    <div class="rows">
      <div class="container">
        <div class="col-xs-3">
          <label for="dateCreation">
            Maîtrises
          </label>
          <treeselect class="tree-select" v-if="maitrises.treeSelectMaitrises"
                    ref="treeDates"
                    :multiple="true"
                    v-model="maitrises.filters.idMaitrises"
                    :searchable="true"
                    :options="maitrises.treeSelectMaitrises"
                    sortValueBy="LEVEL"
                    :default-expand-level="1"
                    :limit="3"
                    :limitText="count => `et ${count} de plus`"
                    :max-height="300"
                    placeholder="Maîtrises sélectionnés"
                    :allways-opened="false"
                    :disable-branch-nodes="true"
                    v-on:change="reloadMaitrises()"
                    @input="reloadMaitrises">
          </treeselect>
        </div>
      </div>
    </div>

    <div v-for="(value, label) in maitrisesStatus">
      <h3>{{label}}</h3>
      <div class="row" v-for="maitrise in maitrises.filteredMaitrises" v-if="maitrise.actif == value && maitrise.deleted === false" v-bind:key="maitrise.id">
        <div class="col-xs-5">
          <span class="title-item">Nom, prénom</span>
          <span class="text-item">{{maitrise.nom}}, {{maitrise.prenom}}</span>
        </div>
        <div class="col-xs-5">
          <span class="title-item">Arrondissement de rattachement</span>
          <span class="text-item">
            {{ maitrise.arrondissement_id | arrondissementName }}
          </span>
        </div>
        <div class="col-xs-2">
          <div class="actions">
            <a class="action-edit" v-on:click="$emit('edit', maitrise)" v-if="maitrise.actif">
              <img src="../../../../static/img/edit-icon.svg">
            </a>
            <a class="action-delete right-separator" v-on:click="$emit('delete', maitrise)" v-if="maitrise.actif">
              <img src="../../../../static/img/delete-icon.svg">
            </a>
            <a class="action-delete right-separator" v-on:click="$emit('reactivate', maitrise)" v-if="!maitrise.actif">
              Réactiver
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import { mapState } from 'vuex'
  import _ from 'lodash'
  import Treeselect from '@riophae/vue-treeselect'

  export default {
    components: {Treeselect},
    computed: {
      ...mapState([
        'maitrises',
      ]),
    },
    data: function () {
      return {
        maitrisesStatus: { 'Actifs': true, 'Inactifs': false },
      }
    },
    mounted: function () {
      this.$store.dispatch('fetchMaitrisesByVilleId');
    },
    methods: {
      reloadMaitrises: function () {
        if (this.maitrises.filters.idMaitrises.length > 0) {
          console.log("filters => ", this.maitrises.filters.idMaitrises);
          this.maitrises.filteredMaitrises = this.maitrises.data.filter(maitrise =>
            this.maitrises.filters.idMaitrises.some(m => maitrise.id === m)
          );
        } else {
          this.maitrises.filteredMaitrises = this.maitrises.data;
        }
        console.log(this.maitrises.filteredMaitrises);
        this.$store.dispatch('updateMaitriseFilter');
      },
    },
  }
</script>

<style lang="scss">
  .rows.maitrises {
    margin-top: -35px;
  }
  h3 {
    text-transform: capitalize
  }
</style>



// WEBPACK FOOTER //
// MaitrisesList.vue?3ded0e60